import { Page } from '@/core/architecture'

import { EmailNotificationSettingsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * EmailNotificationSettings Page
 * Implemented as a practical sample.
 */
export const EmailNotificationSettings: Page = () => {
  const { state, actions } = useViewModel()

  return <EmailNotificationSettingsTemplate state={state} {...actions} />
}
